module.exports = __webpack_public_path__ + "svg/s-home-about.svg";